export const GRID_COLS = 7;
export const GRID_ROWS = 6;

export const CELL_SIZE = 52;
export const CELL_GAP = 6;
export const GRID_PADDING = 30;

export const BLOCK_COLORS = {
  prisoner: '#FFD700',
  green: '#4ADE80',
  pink: '#F472B6',
  purple: '#A78BFA',
  cyan: '#22D3EE',
  orange: '#FB923C',
  blue: '#3B82F6',
  red: '#EF4444',
};

export const BLOCK_COLOR_LIST = [
  BLOCK_COLORS.green,
  BLOCK_COLORS.pink,
  BLOCK_COLORS.purple,
  BLOCK_COLORS.cyan,
  BLOCK_COLORS.orange,
  BLOCK_COLORS.blue,
  BLOCK_COLORS.red,
];

export const DIFFICULTY_CONFIG = {
  easy: {
    minBlocks: 4,
    maxBlocks: 4,
    minMoves: 3,
    maxMoves: 4,
    label: 'Easy',
  },
  medium: {
    minBlocks: 5,
    maxBlocks: 6,
    minMoves: 5,
    maxMoves: 6,
    label: 'Medium',
  },
  hard: {
    minBlocks: 7,
    maxBlocks: 8,
    minMoves: 6,
    maxMoves: 8,
    label: 'Hard',
  },
};

export const BLOCK_SIZES = [
  { width: 2, height: 1, orientation: 'H' },
  { width: 3, height: 1, orientation: 'H' },
  { width: 1, height: 2, orientation: 'V' },
  { width: 1, height: 3, orientation: 'V' },
  { width: 1, height: 1, orientation: 'H' },
];

export const PRISONER_ROW_OPTIONS = [0, 1, 2, 3, 4, 5];

export const EXIT_COL = GRID_COLS;
